import { FunctionComponent, useMemo } from 'react'
import {
  useFilters,
  useGetSubSpecialtiesFilter
} from '@/modules/accredited-establishments/hooks'
import {
  DropdownChip,
  DropdownChipItem
} from '@/modules/accredited-establishments/components/Filters/DropdownChip'
import {
  ATTENDANCE_OPTIONS,
  GENDER_OPTIONS
} from './SpecialistFilters.constants'
import {
  toAccreditedGender,
  toAppointmentType
} from '@/modules/accredited-establishments/functions/parse-enum-param'
import { getSpecialistChainState } from './SpecialistFilters.helpers'

const SpecialistFilters: FunctionComponent = () => {
  const {
    categories,
    specialties,
    specialty,
    subSpecialty,
    gender,
    appointmentType,
    updateSpecialty,
    updateSubSpecialty,
    updateGender,
    updateAppointmentType
  } = useFilters()

  const specialtyItems = useMemo<DropdownChipItem[]>(
    () =>
      (specialties?.items || []).map(({ title, value }) => ({
        label: title,
        value
      })),
    [specialties]
  )

  const { data: subSpecialties } = useGetSubSpecialtiesFilter(specialty?.value)

  const subSpecialtyItems = useMemo<DropdownChipItem[]>(
    () =>
      (subSpecialties?.items || []).map(({ title, value }) => ({
        label: title,
        value
      })),
    [subSpecialties]
  )

  const chain = getSpecialistChainState({
    specialty: specialty?.value
  })

  if (!categories.includes('SPECIALIST')) {
    return null
  }

  return (
    <>
      <DropdownChip
        placeholder='Especialidade'
        items={specialtyItems}
        value={specialty?.value}
        disabled={chain.specialty.disabled || !specialtyItems.length}
        onChange={({ label, value }) =>
          updateSpecialty({ title: label, value })
        }
      />

      <DropdownChip
        placeholder='Subespecialidade'
        items={subSpecialtyItems}
        value={subSpecialty?.value}
        disabled={chain.subSpecialty.disabled || !subSpecialtyItems.length}
        onChange={({ label, value }) =>
          updateSubSpecialty({ title: label, value })
        }
      />

      <DropdownChip
        placeholder='Gênero'
        items={GENDER_OPTIONS}
        value={gender}
        disabled={chain.gender.disabled}
        onChange={({ value }) => updateGender(toAccreditedGender(value))}
      />

      <DropdownChip
        placeholder='Atendimento'
        items={ATTENDANCE_OPTIONS}
        value={appointmentType}
        disabled={chain.attendance.disabled}
        onChange={({ value }) =>
          updateAppointmentType(toAppointmentType(value))
        }
      />
    </>
  )
}

export { SpecialistFilters }
